import {statisticsService} from '../../services/service-factory';

export default {
  data: function() {
    return {
      statisticsService: undefined
    };
  },
  created: function() {
    this.statisticsService = statisticsService;
  }
};
